module.exports = __webpack_public_path__ + "static/media/pic-quiz-geldwaescherei-1.b4ad6308.jpg";